export default __webpack_public_path__ + "static/media/bg-7.6a2cd2fc.jpg";